import React from 'react';
import useGlobalHotkey from '~app/core/useGlobalHotkey';
import withEnterToClick from '~app/core/withEnterToClick';

const ClickOrEnterDiv = withEnterToClick('div');

// Continue dialog with only continue button
const ContinueDialog = ({ onContinue, title, text, continueLabel }) => {
  useGlobalHotkey({
    hotkey: 'Escape',
    callback: onContinue,
    event: 'keyup',
    priority: 10,
    stop: true,
  });
  return (
    <div className="ConfirmationDialog Modal__container">
      <h1 className="ConfirmationDialog__title">{title}</h1>
      <div className="ConfirmationDialog__text">{text}</div>
      <div className="ConfirmationDialog__button-group">
        <ClickOrEnterDiv
          className="ConfirmationDialog__button"
          onClick={onContinue}
          role="button"
          tabIndex={0}
        >
          {continueLabel}
        </ClickOrEnterDiv>
      </div>
    </div>
  );
};

export default ContinueDialog;
